import axios from 'axios'

import type { InvoiceAddress, PaymentParams, PaymentMethod } from '../../../schema/payment'
import { getApiUrl, PAYMENT_API_URL } from '../../util/api/api'

const startPayment = (
  productCodes: Array<string>,
  paymentMethod: PaymentMethod,
  paymentParams?: PaymentParams,
  poNumber?: string,
  invoiceAddress?: InvoiceAddress,
) =>
  axios.post(
    getApiUrl(PAYMENT_API_URL),
    {
      productCodes,
      paymentMethod,
      paymentParams,
      poNumber,
      invoiceAddress,
    },
    {
      withCredentials: true,
    },
  )

export default startPayment
